import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const FooterLoanAmounts = () => {
  return (
    <div className="flex flex-col">
      <h3 className="text-lg font-semibold mb-4 text-white flex items-center justify-center md:justify-start">
        <Sparkles className="h-5 w-5 text-yellow-400 mr-2" />
        Hae lainaa summalle
      </h3>
      <div className="grid grid-cols-2 gap-2">
        <Link 
          to="/lainat/kulutusluotto?amount=1000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 1000 euron kulutusluottoa"
          title="Pienlaina 1000 euroa ilman vakuuksia"
        >
          1 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=2000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 2000 euron kulutusluottoa"
          title="Kulutusluotto 2000 euroa joustavilla ehdoilla"
        >
          2 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=5000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 5000 euron kulutusluottoa"
          title="Edullinen 5000 euron laina erilaisiin tarpeisiin"
        >
          5 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=10000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 10000 euron kulutusluottoa"
          title="10000 euron laina isompiin hankintoihin"
        >
          10 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=15000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 15000 euron kulutusluottoa"
          title="15000 euron laina remonttiin tai isompiin hankintoihin"
        >
          15 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=20000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 20000 euron kulutusluottoa"
          title="20000 euron laina ilman vakuuksia isompiin hankintoihin"
        >
          20 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=30000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 30000 euron kulutusluottoa"
          title="30000 euron vakuudeton laina suurempiin tarpeisiin"
        >
          30 000 €
        </Link>
        <Link 
          to="/lainat/kulutusluotto?amount=50000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 50000 euron kulutusluottoa"
          title="50000 euron laina suurempiin hankintoihin"
        >
          50 000 €
        </Link>
        <Link 
          to="/lainat/asuntolaina?amount=100000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 100000 euron asuntolainaa"
          title="100000 euron asuntolaina edullisilla ehdoilla"
        >
          100 000 €
        </Link>
        <Link 
          to="/lainat/asuntolaina?amount=200000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 200000 euron asuntolainaa"
          title="200000 euron asuntolaina kilpailukykyisellä korolla"
        >
          200 000 €
        </Link>
        <Link 
          to="/lainat/asuntolaina?amount=300000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 300000 euron asuntolainaa"
          title="300000 euron asuntolaina kodin hankintaan"
        >
          300 000 €
        </Link>
        <Link 
          to="/lainat/asuntolaina?amount=500000" 
          className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-2 px-3 rounded text-center text-sm hover:scale-105 transform duration-200"
          aria-label="Hae 500000 euron asuntolainaa"
          title="500000 euron asuntolaina unelmiesi kotiin"
        >
          500 000 €
        </Link>
      </div>
    </div>
  );
};

export default FooterLoanAmounts;
